"use client";
import { useEffect } from "react";
const RedirectToExternalURL = ({ externalUrl }: { externalUrl: string }) => {
  useEffect(() => {
    window.location.href = externalUrl; // Redirect the browser
  }, []);
  return <></>;
};

export default RedirectToExternalURL;
